import { pgTable, uuid, text } from "drizzle-orm/pg-core";
import { relations } from "drizzle-orm";
import { user } from "../../auth/core/user.sql";
import { id } from "../../utils/sql";
import { list } from "../list/list.sql";

// Might actually re-use this to implement the Things 3 "Area" concept for lists?
// Or should this be an independent concept?
export const listCollection = pgTable("list_collection", {
  ...id,
  name: text("name").notNull(),
  defaultForUserId: uuid("default_for_user_id")
    .references(() => user.id)
    .unique(),
});

export const listCollectionRelations = relations(listCollection, ({ many }) => ({
  lists: many(list),
}));
